const colorsCharts = {
    treeMap: {
        green500: 'var(--green-500)',
        green400: 'var(--green-400)',
        green300: 'var(--green-300)',
        yellow400: 'var(--yellow-400)',
        orange400: 'var(--orange-500)',
        red100: 'var(--red-100)',
        red200: 'var(--red-200)',
        red300: 'var(--red-300)',
        red400: 'var(--red-400)',
        red500: 'var(--red-500)',
        red700: 'var(--red-700)'
    },
    colorDefault: [
        'var(--green-500)',
        'var(--green-400)',
        'var(--yellow-400)',
        'var(--orange-500)',
        'var(--red-400)'
    ],
    speedometer: [
        'var(--red-400)',
        'var(--yellow-400)',
        'var(--green-400)',
        'var(--yellow-400)',
        'var(--red-400)'
    ],
    stockChart: [
        'var(--green-300)',
        'var(--green-400)',
        'var(--yellow-300)',
        'var(--yellow-400)',
        'var(--orange-300)',
        'var(--red-300) ',
        'var(--red-400) '
    ],
    stockChartTC: [
        'var(--green-400)',
        'var(--yellow-400)',
        'var(--orange-400)',
        'var(--red-400) '
    ]
}

const curvesColorsCharts = () => {
    const curves = [
        { name: 'AA', color: colorsCharts.treeMap.green500 },
        { name: 'A', color: colorsCharts.treeMap.green300 },
        { name: 'B', color: colorsCharts.treeMap.yellow400 },
        { name: 'C', color: colorsCharts.treeMap.red500 },
        { name: 'CC', color: colorsCharts.treeMap.red700 }
    ]

    function treeMap() {
        return curves.map(curve => {
            return {
                ...curve,
                id: `Curva ${curve.name}`,
                name: `Curva ${curve.name}`
            }
        })
    }

    function histogram() {
        return curves.map(curve => {
            return {
                ...curve,
                data: []
            }
        })
    }

    return { treeMap, histogram }
}

export { colorsCharts, curvesColorsCharts }
export default colorsCharts
